<template>
  <div class="custom-popup">
    <table>
      <tr>
        <td>السرعة</td>
        <td>{{ point.speed}}</td>
      </tr>

      <tr>
        <td>الحالة</td>
        <td>{{ point.status}}</td>
      </tr>

      <tr>
        <td>التوقيت</td>
        <td>{{ point.time}}</td>
      </tr>

      <tr>
        <td>الموقع</td>
        <td>
          <a target="_blank" :href="`https://maps.google.com/maps?q=${point.lat},${point.long}`">
            {{point.lat}},{{point.long}}
          </a>
        </td>
      </tr>

    </table>
  </div>
</template>

<script>
export default {
  name: 'PointPopup',
  props: {
    point: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
